import React, { useEffect, useState, useContext } from "react";
import * as styledComponents from "./styles";
import { Container, Row } from "react-bootstrap";
import ItemElement from "../components/ItemElement";
import { CombSpinner } from "react-spinners-kit";
import { CartContext } from "contexts/CartContext";
import { useAlert } from "react-alert";
import SearchIconSVG from "components/SearchIcon";
import { useQuery } from "react-query";
import {itemsAPI, cmsHeaders} from 'api/hosts';

const ShopItems = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const { cart, updateCart } = useContext(CartContext);
  const alert = useAlert();

  const { isLoading, error, data } = useQuery("shopItems", () =>
    fetch(itemsAPI, cmsHeaders).then((res) => res.json())
  );

  if (isLoading) return "Loading...";

  if (error) return "An error has occurred: " + error.message;

  const items = data.data || [];

  const addItemToCart = (item) => {
    const newCart = cart?.length ? [...cart, item] : [item];
    updateCart(newCart);
    alert.show(`${item.name} added to cart`, { type: "success" });
  };

  const handleSearchItem = (e) => {
    const searchTerm = e.target.value;
    setSearchTerm(searchTerm);
  };

  return (
    <styledComponents.ShopItemsContainer>
      <Container>
        <Row>
          <styledComponents.SearchBarContainer>
            <styledComponents.SearchBar
              placeholder={"Web, 3D, AR..."}
              onChange={handleSearchItem}
            />
            <styledComponents.IconSearch>
              <SearchIconSVG />
            </styledComponents.IconSearch>
          </styledComponents.SearchBarContainer>
          {isLoading && (
            <styledComponents.ContainerLoader>
              <CombSpinner color="#FFFFFF" />
            </styledComponents.ContainerLoader>
          )}
          {!isLoading &&
            items
              .filter(
                (item) =>
                  item.attributes.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                  item.attributes.description.toLowerCase().includes(searchTerm)
              )
              ?.map((item, idx) => {
                return (
                  <ItemElement
                    idx={idx}
                    key={idx}
                    item={item}
                    addItemToCart={addItemToCart}
                  />
                );
              })}
        </Row>
      </Container>
    </styledComponents.ShopItemsContainer>
  );
};

export default ShopItems;
